export default __webpack_public_path__ + "static/media/shield-checked.534d78d8.png";